export const navLinks = [
  { label: 'Expertise', href: '/expertise' },
  { label: 'Work', href: '/work' },
  { label: 'Insights', href: '/insights' },
  { label: 'Contact', href: '/contact' },
];

export const allAnchors = [
  { label: 'About', href: '#about' },
  { label: 'Expertise', href: '/expertise' },
  { label: 'Work', href: '/work' },
  { label: 'People', href: '#people' },
  { label: 'Insights', href: '/insights' },
  { label: 'Contact', href: '/contact' },
];

export const expertise = [
  {
    no: '01',
    tag: 'Direction',
    title: 'Business Strategy',
    text: 'Clear choices on where to play and how to win, shaped into a strategy people can act on.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_exp01.webp',
  },
  {
    no: '02',
    tag: 'Organization',
    title: 'Organizational Transformation',
    text: 'Structures, roles and ways of working redesigned around what the organization must become.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_exp02.webp',
  },
  {
    no: '03',
    tag: 'Execution',
    title: 'Operational Excellence',
    text: 'Operating models that remove friction: clear decision rights, focused governance, consistent delivery.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_exp03.webp',
  },
];

export const approach = [
  { no: '01', title: 'Understand', text: 'An honest read of facts and people to find what really holds performance back.' },
  { no: '02', title: 'Align', text: 'Leaders work through the hard trade-offs and reach decisions that hold.' },
  { no: '03', title: 'Deliver', text: 'We stay through implementation, then step back once momentum is your own.' },
];

export const work = [
  {
    slug: 'growth-strategy',
    sector: 'Industrial Manufacturing',
    title: 'Reframing a growth strategy',
    text: 'A manufacturer with a crowded portfolio focuses investment on the few segments where it can genuinely win.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_work01.webp',
  },
  {
    slug: 'operating-model',
    sector: 'Financial Services',
    title: 'Designing a resilient operating model',
    text: 'A financial group simplifies overlapping functions and clarifies who decides what.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_work02.webp',
  },
  {
    slug: 'leadership-alignment',
    sector: 'Healthcare',
    title: 'Aligning leaders around change',
    text: 'A newly combined executive team agrees its priorities and leads an integration with one voice.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_work03.webp',
  },
];

export const people = [
  {
    name: 'Helena Marsh',
    role: 'Managing Partner',
    focus: 'Strategy & Leadership Alignment',
    note: 'Works with executive teams on direction-setting and the conversations that make it stick.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_person01.webp',
  },
  {
    name: 'Daniel Okafor',
    role: 'Partner',
    focus: 'Transformation & Operating Model',
    note: 'Helps organizations redesign how decisions, roles and teams fit together.',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_person02.webp',
  },
];